import { Injectable } from '@angular/core';
import { Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions } from '@angular/http';

import { API_ENDPOINTS } from '../../shared/configuration/api-endpoints';

import { StorageService } from '../../shared/services/storage.service';
import { ErrorService } from '../../shared/services/error.service';
import { PopupService } from '../../shared/services/pop-up.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { ValidationService } from 'app/shared/services/validation.service';

@Injectable()
export class RegisterService {

    vRegisterData: {
        email: string,
        retype_email: string,
        password: string,
        retype_password: string,
        security_question: string,
        security_answer: string,
        first_name: string,
        last_name: string,
        company_reg_no: string,
        phone_no: string,
        company_name: string,
        designation: string,
        address_line_1: string,
        address_line_2: string,
        building_name: string,
        postal_code: string,
        registration_type: string,
        licence_id: string
    };

    vLoadingStatus: boolean;
    vSuccessMessage: string;

    constructor(
        private _http: Http,
        private _errorService: ErrorService,
        private _storageService: StorageService,
        private _popupService: PopupService,
        private _pageNavigationService: PageNavigationService,
        private _validationService: ValidationService
    ) {
        this.vLoadingStatus = false;
        this.vSuccessMessage = "";
    }

    getRegisterData() {
        console.log("Line 49", this.vRegisterData.registration_type);
        return this.vRegisterData;
    }

    getSuccessMessage() {
        return this.vSuccessMessage;
    }

    isLoading() {
        return this.vLoadingStatus;
    }

    resetRegistrationData() {
        this.vRegisterData = {
            email: "",
            retype_email: "",
            password: "",
            retype_password: "",
            security_question: "",
            security_answer: "",
            first_name: "",
            last_name: "",
            company_reg_no: "",
            phone_no: "",
            company_name: "",
            designation: "",
            address_line_1: "",
            address_line_2: "",
            building_name: "",
            postal_code: "",
            registration_type: '0',
            licence_id: ''
        };
    }

    resetError() {
        this._errorService.resetErrorFlag();
        this._errorService.resetError();
        this._errorService.resetBackEndError();
    }

    validateRegisterInput() {

        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.vRegisterData.email)) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('email', 'The email address format is invalid.');
        }
        if (this.vRegisterData.email !== this.vRegisterData.retype_email) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('retypeEmail', 'The email address and confirm email address does not match.');
        }

        if (this.vRegisterData.password !== this.vRegisterData.retype_password) {
            this._errorService.setErrorFlag(true);
            //this._errorService.setErrorStatusAndMessage('Confirm Password', 'The password are not match');
            this._errorService.setErrorStatusAndMessage('retypePassword', 'The password and confirm password does not match.');//Changed by Anjaiah
        }
        // Checking if the minimum password length is 12 characters as part of APOLLO project.
        if (!/.{12,}$/.test(this.vRegisterData.password)) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('password', 'Password must be at least 12 characters');
        }

        //Added by Anjaiah
        /* if(!/\d/.test(this.vRegisterData.password) && !/[A-Z]/.test(this.vRegisterData.password) && !/[a-z]/.test(this.vRegisterData.password) && !/(?=.*[!@#\$%\^&\*])/g.test(this.vRegisterData.password)){
             this._errorService.setErrorFlag(true);
             this._errorService.setErrorStatusAndMessage('password', 'Password must be at least 12 characters long with one uppercase letter, one lowercase letter, one number and one special character.');
         }*/
        //Kowsalya - Commented by Anjaiah
        if (!/\d/.test(this.vRegisterData.password)) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('password', 'Password must be at least 12 characters long with 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character.');
        }

        if (!/[A-Z]/.test(this.vRegisterData.password)) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('password', 'Password must be at least 12 characters long with 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character.');
        }

        if (!/[a-z]/.test(this.vRegisterData.password)) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('password', 'Password must be at least 12 characters long with 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character.');
        }
        if (!/(?=.*[!@#\$%\^&\*])/g.test(this.vRegisterData.password)) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('password', 'Password must be at least 12 characters long with 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character.');
        }
        //Kowsalya
        /*if(!/^\+?\d+$/.test(this.vRegisterData.phone_no)){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('phoneNo', 'The phone number is invalid.');
        }
        if(this.vRegisterData.phone_no.length!=8){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('phoneNo', 'Phone number length should be 8');
        }*/
        //Anjaiah
        if (!/^[6|8|9][0-9]{7}$/.test(this.vRegisterData.phone_no)) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('phoneNo', 'The phone no. format is invalid.');
        }

        if (!/^[0-9]+$/.test(this.vRegisterData.postal_code)) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('postalCode', 'The postal code is invalid.');
        }
        if (this.vRegisterData.postal_code.length != 6) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('postalCode', 'The postal code format is invalid.');
        }
        if (!/^[a-zA-Z ]*$/.test(this.vRegisterData.designation)) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('designation', 'Designation provided is not valid');

        }
        //Priya
        if (this.vRegisterData.security_answer.trim() === '' || this.vRegisterData.security_answer.trim() === undefined) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('securityanswer', 'Security answer is empty');

        }
        if (this.vRegisterData.security_question.trim() === '' || this.vRegisterData.security_question.trim() === undefined) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('securityquestion', 'Security question is empty');

        }

        if (this.vRegisterData.registration_type !== undefined || this.vRegisterData.registration_type !== '') {
            if ((this.vRegisterData.registration_type === '0')) {
                if ((!/[a-zA-Z]/.test(this.vRegisterData.company_reg_no) || !/[0-9]/.test(this.vRegisterData.company_reg_no))) {
                    this._errorService.setErrorFlag(true);
                    this._errorService.setErrorStatusAndMessage('companyreg', 'The UEN format is invalid.');
                }
                else {
                    this._validationService.validateUEN(this.vRegisterData.company_reg_no);
                }
            } else {
                if (!/[a-zA-Z]/.test(this.vRegisterData.licence_id) || !/[0-9]/.test(this.vRegisterData.licence_id)) {
                    this._errorService.setErrorFlag(true);
                    this._errorService.setErrorStatusAndMessage('licence', 'The license ID format is invalid.');
                }
            }
        }
    }

    isDisableRegister() {
        if (this.vRegisterData.email.trim() === undefined || this.vRegisterData.email.trim() === '') {
            return true;
        }
        else if (this.vRegisterData.retype_email.trim() === undefined || this.vRegisterData.retype_email.trim() === '') {
            return true;
        }
        else if (this.vRegisterData.password.trim() === undefined || this.vRegisterData.password.trim() === '') {
            return true;
        }
        else if (this.vRegisterData.retype_password.trim() === undefined || this.vRegisterData.retype_password.trim() === '') {
            return true;
        }
        /* else if(this.vRegisterData.security_question.trim() === undefined || this.vRegisterData.security_question.trim() === ''){
             return true;
         }
         else if(this.vRegisterData.security_answer.trim() === undefined || this.vRegisterData.security_answer.trim() === ''){
             return true;
         }*/
        else if (this.vRegisterData.registration_type === undefined || this.vRegisterData.registration_type === '') {
            return true;
        }
        else if (this.vRegisterData.first_name.trim() === undefined || this.vRegisterData.first_name.trim() === '') {
            return true;
        }
        else if (this.vRegisterData.last_name.trim() === undefined || this.vRegisterData.last_name.trim() === '') {
            return true;
        }
        else if ((this.vRegisterData.licence_id.trim() === undefined || this.vRegisterData.licence_id.trim() === '') && (this.vRegisterData.registration_type === '1')) {
            return true;
        }
        else if ((this.vRegisterData.company_reg_no.trim() === undefined || this.vRegisterData.company_reg_no.trim() === '') && (this.vRegisterData.registration_type === '0')) {
            return true;
        }
        else if (this.vRegisterData.phone_no.trim() === undefined || this.vRegisterData.phone_no.trim() === '') {
            return true;
        }
        else if ((this.vRegisterData.company_name.trim() === undefined || this.vRegisterData.company_name.trim() === '') && (this.vRegisterData.registration_type === '0')) {
            return true;
        }
        else if ((this.vRegisterData.designation.trim() === undefined || this.vRegisterData.designation.trim() === '') && (this.vRegisterData.registration_type === '0')) {
            return true;
        }
        else if (this.vRegisterData.address_line_1.trim() === undefined || this.vRegisterData.address_line_1.trim() === '') {
            return true;
        }
        else if (this.vRegisterData.postal_code.trim() === undefined || this.vRegisterData.postal_code.trim() === '') {
            return true;
        }

        return false;
    }

    userRegister() {
        this.resetError();
        this.validateRegisterInput();

        if (this._errorService.getErrorFlag()) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Some of the required information is invalid or missing. Please correct them before proceeding with the account registration. Thank You.', '', false, false);
            return;
        }

        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.AUTH.REGISTER, this.vRegisterData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                console.log(response);
                this._storageService.setSessionItem("temporaryEmail", this.vRegisterData.email);
                this._pageNavigationService.navigate(['registration-confirmation']);
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                if (vErrorData.code === 903) {
                    this._errorService.setErrorStatusAndMessage('email', 'This email address already exists.');
                    this._popupService.openGeneralConfirmationPopup('Notice', 'This email address you entered already exists. Please check and provide another email address. Thank You.', '', false, false);
                } else if (vErrorData.code === 801) {
                    this._popupService.openGeneralConfirmationPopup('Notice', 'Registration failed. Please try again', '', false, false);
                } else {
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
            }
        );
    }

    resendCode() {
        this.resetError();

        var xData = {
            email: this._storageService.getSessionItem("temporaryEmail")
        }

        this.vSuccessMessage = "";
        this.vLoadingStatus = true;

        this._http.post(API_ENDPOINTS.AUTH.RESEND_CODE, xData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                console.log(response);
                this.vSuccessMessage = "We have sent your verification code to your email. Please enter the verification code to complete the sign up.";
            },
            (error) => {
                this.vLoadingStatus = false;
                let vErrorData = error;
                console.log(vErrorData);
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    confirmCode(pConfirmationCode) {
        this.resetError();
        this.vSuccessMessage = "";
        var xData = {
            email: this._storageService.getSessionItem("temporaryEmail"),
            confirmation_code: pConfirmationCode
        }

        this.vLoadingStatus = true;

        this._http.post(API_ENDPOINTS.AUTH.CONFIRM_REGISTRATION, xData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                console.log(response);
                this._storageService.removeSessionItem("temporaryEmail");
                this._pageNavigationService.navigate(['registration-success']);
            },
            (error) => {
                this.vLoadingStatus = false;
                let vErrorData = error;
                console.log(vErrorData);
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/login/services/register.service.ts